import { render, staticRenderFns } from "./ButtonDoublecheck.vue?vue&type=template&id=52f18b73&"
import script from "./ButtonDoublecheck.vue?vue&type=script&lang=js&"
export * from "./ButtonDoublecheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports